import BaseService from "./base.service";

class DisciplinaryGradationService extends BaseService {
  constructor() {
    super("disciplinary-gradation");
  }
}

export default new DisciplinaryGradationService();
